import { render } from "./ResetarLances.vue?vue&type=template&id=f1b8ee3e"
import script from "./ResetarLances.vue?vue&type=script&lang=js"
export * from "./ResetarLances.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__